import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { ContentProvider } from "./contexts/ContentContext";
import { AuthProvider } from "./contexts/AuthContext";
import Home from "./pages/Home";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import SeoHead from "./components/SeoHead";
import { ReservationProvider } from "./components/ReservationDialog";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <ContentProvider>
                    <BrowserRouter>
                        <ReservationProvider>
                            <SeoHead />
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/admin/login" element={<AdminLogin />} />
                                <Route path="/admin" element={<Admin />} />
                            </Routes>
                            <Toaster position="top-right" richColors />
                        </ReservationProvider>
                    </BrowserRouter>
                </ContentProvider>
            </AuthProvider>
        </div>
    );
}

export default App;
